import React from "react";
import RNToast from "react-native-toast-notifications";
import ToastMessage from "./ToastMessage-component";

interface ToastType {
  children?: React.ReactNode;
}
const Toast = React.forwardRef((props: ToastType, ref) => (
  <RNToast
    ref={ref}
    placement="top"
    animationType="slide-in"
    animationDuration={400}
    renderToast={(options) => {
      return (
        <ToastMessage
          message={options.message}
          options={{
            actionText: options.data?.actionText,
            action: options.data?.action,
            type: options.data?.type,
            showDismiss: options.data?.showDismiss,
          }}
        />
      );
    }}
  >
    {props.children}
  </RNToast>
));

export default Toast;
